import { render, staticRenderFns } from "./tag-selector.vue?vue&type=template&id=b37c989a"
import script from "./tag-selector.vue?vue&type=script&lang=ts"
export * from "./tag-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports